import { apiSlice } from './apiSlice';

export interface NotificationItem {
  id: number;
  title: string;
  body: string;
  type: string;
  data: Record<string, unknown>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationsResponse {
  data: Record<string, NotificationItem[]>;
  pagination: {
    total: number;
    limit: number;
    currentPage: number;
    totalPage: number;
  };
}

export interface NotificationsParams {
  type?: string;
}

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationsResponse, NotificationsParams | void>({
      query: (params) => ({
        url: '/notifications',
        method: 'GET',
        params: { t: Date.now(), ...(params?.type ? { type: params.type } : {}) },
      }),
    }),
  }),
});

export const { useGetNotificationsQuery } = notificationApi;
